import { useCallback, useMemo } from 'react'
import { useSortBy } from 'react-instantsearch'
import { Text, Stack } from '@leroy-merlin-br/backyard-react'

import { Select } from 'site/EntryKey/components/Facets/components'
import { onSorterDataLayer } from 'site/AlgoliaEntryKey/utils/data-layer'

import * as S from './styled'
import { Card } from '../Card'
import { useAlgoliaContext } from '../../context/algolia-context'

type Option = {
  value: string
  label: string
}

const PLACEHOLDER = 'Mais Relevantes'

const sortByOptions = (indexName: string) => {
  return [
    { label: 'Maior Preço', value: `${indexName}_price_desc` },
    { label: 'Menor Preço', value: `${indexName}_price_asc` },
    { label: 'Maior Desconto', value: `${indexName}_discount` },
    { label: 'Mais Vendidos', value: `${indexName}_most_sales` },
    { label: 'Novidades', value: `${indexName}_novelty` }
  ]
}

interface SortByProps {
  indexName: string
}

const SortBy = ({ indexName }: SortByProps) => {
  const { gaTrack, query } = useAlgoliaContext()
  const { options, refine, currentRefinement } = useSortBy({
    items: sortByOptions(indexName)
  })
  const findSelectedOption = useCallback(
    (searchValue: string) => options.find((opt) => opt.value === searchValue),
    [options]
  )

  const handleChange = (value: string) => {
    const option = value ? (findSelectedOption(value) as Option) : options[0]

    const url = new URL(window.location.href)
    onSorterDataLayer({
      gaTrack,
      term: query,
      isParamAlreadySet: url.searchParams.has('sortBy'),
      sorterType: option.label
    })

    refine(value || indexName)
  }

  const selectedOption = useMemo(() => {
    if (!currentRefinement) {
      return undefined
    }

    return findSelectedOption(currentRefinement)
  }, [currentRefinement, findSelectedOption])

  return (
    <S.Wrapper data-cy="sorter-filter">
      <Card target="sorter">
        <Stack space="kilo">
          <Text as="strong" size="giga" color="n900" isBold noMargin>
            Ordenar por
          </Text>

          <S.WrapperSelect title={selectedOption?.label ?? PLACEHOLDER}>
            <Select
              onChange={(_: number, value: string) => handleChange(value)}
              placeholder={PLACEHOLDER}
              name={selectedOption?.label ?? ''}
              value={selectedOption?.value ?? ''}
            >
              {options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Select>
          </S.WrapperSelect>
        </Stack>
      </Card>
    </S.Wrapper>
  )
}

export default SortBy
